import { useContext } from 'react';
import { TasksTabContext, TasksTabContextValue } from '../../context/TasksContext';

export const useTasksTab = (): TasksTabContextValue => {
  const ctx = useContext(TasksTabContext);
  if (!ctx) throw new Error('useTasksTab must be used inside TasksTabProvider');
  return ctx;
};
